// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const NODE_ENV = (window as any).NODE_ENV ?? 'development';

export const isDevServer = NODE_ENV === 'development';
export const isDevBuild = NODE_ENV === 'build-dev';
export const isProdBuild = NODE_ENV === 'production';

export const host = window.location.hostname;

export const isS3Fast = ['yastatic.net'].includes(host);
export const isS3Slow = ['milab.s3.yandex.net', 's3.mds.yandex.net'].includes(host);
export const isS3 = isS3Fast || isS3Slow;
export const isProd = isS3Fast;

export const isLocal = ['127.0.0.1', '0.0.0.0', 'localhost'].includes(host);
export const isFileProtocol = window.location.protocol === 'file:';
export const isUnexpected = !isS3 && !isFileProtocol && !isLocal;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isTestCompany = (window as any).isTestCompany;
